export type ConversationPreset = {
  id: string;
  role: "incoming" | "outgoing";
  initials: string;
  text: string;
  time: string;
  message_type: string;
  metadata?: {
    table_id?: string;
    table_name?: string;
  };
};

export const presetConversations: ConversationPreset[] = [
  {
    id: "msg-1",
    role: "incoming",
    initials: "CP",
    message_type: "text",
    metadata: {
      table_id: "table-1",
      table_name: "CleanPro Services",
    },
    text: "Hello! Thank you for choosing CleanPro Services.",
    time: "9:00 AM",
  },
  {
    id: "msg-2",
    role: "outgoing",
    initials: "",
    message_type: "text",
    metadata: {
      table_id: "table-2",
      table_name: "Booking Confirmation",
    },
    text: "Hi! I wanted to confirm my booking for tomorrow.",
    time: "9:05 AM",
  },
  {
    id: "msg-3",
    role: "incoming",
    initials: "CP",
    message_type: "text",
    metadata: {
      table_id: "table-3",
      table_name: "Deep Cleaning",
    },
    text: "Yes, your deep cleaning is scheduled for tomorrow.",
    time: "9:06 AM",
  },
  {
    id: "msg-4",
    role: "outgoing",
    initials: "",
    message_type: "text",
    metadata: {
      table_id: "table-4",
      table_name: "Booking Confirmation",
    },
    text: "Great. What time will the team arrive?",
    time: "9:10 AM",
  },
  {
    id: "msg-5",
    role: "incoming",
    initials: "CP",
    message_type: "text",
    metadata: {
      table_id: "table-5",
      table_name: "Deep Cleaning",
    },
    text: "The team will arrive at 10 AM sharp. Please ensure someone is home.",
    time: "9:12 AM",
  },
  {
    id: "msg-6",
    role: "outgoing",
    initials: "",
    message_type: "text",
    text: "Perfect, I'll be here. Do I need to prepare anything?",
    time: "9:15 AM",
    metadata: {
      table_id: "table-6",
      table_name: "Deep Cleaning",
    },
  },
  {
    id: "msg-7",
    role: "incoming",
    initials: "CP",
    message_type: "text",
    text: "Just clear any fragile items from surfaces. We'll handle the rest!",
    time: "9:16 AM",
    metadata: {
      table_id: "table-7",
      table_name: "Deep Cleaning",
    },
  },
  {
    id: "msg-8",
    role: "incoming",
    initials: "CP",
    message_type: "text",
    text: "Your deep cleaning is confirmed for tomorrow at 10 AM.",
    time: "9:20 AM",
    metadata: {
      table_id: "table-8",
      table_name: "Deep Cleaning",
    },
  },
];
